import type { UsePaginationReturn } from '../../../hooks/usePagination';
import { useUrlParams } from '../../../hooks/useUrlParams';

export function useBranchStockParams(
	pagination: UsePaginationReturn,
	search?: string,
) {
	const recordsParams = useUrlParams({
		branchSearch: search,
		size: pagination.value.pageSize,
		number: pagination.value.pageNumber,
	});

	const countParams = useUrlParams({
		branchSearch: search,
	});

	return {
		recordsParams,
		countParams,
	};
}
